import script from "./Election.vue?vue&type=script&setup=true&lang=js"
export * from "./Election.vue?vue&type=script&setup=true&lang=js"

import "./Election.vue?vue&type=style&index=0&id=68f20d2c&lang=css"

const __exports__ = script;

export default __exports__